import { css } from '@emotion/css';
import { Font, Loader } from 'is24-corecss';
import React from 'react';
import { TEAL200 } from '../../../../../../domain/colors';
import { Msg, useIntl } from '@/i18n';

const styles: any = {
  discountContainer: {
    border: '1px solid rgb(214, 214, 214)',
    borderRadius: '4px',
    padding: '16px',
  },
  discountHeader: {
    fontWeight: 'bold',
    marginBottom: '12px',
  },
  discountCode: {
    padding: '2px 4px',
    borderRadius: '6px',
    backgroundColor: TEAL200,
    wordBreak: 'break-all',
  },
  loaderContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  infoContainer: {
    display: 'flex',
    marginBottom: '20px',
    marginTop: '20px',
  },
  infoIcon: {
    fontSize: '20px',
    lineHeight: '1',
    marginRight: '10px',
  },
};

export const DiscountBox = ({ discountCode, isEntitled }: { discountCode?: string; isEntitled: boolean }) => {
  const { t } = useIntl();
  return (
    <div className={css(styles.discountContainer)}>
      {discountCode ? (
        <>
          <p className={css(styles.discountHeader)}>
            <Msg
              id='benefits.relocationBox.modal.overview.discoutContainer.title'
              defaultMessage={`Dein persönlicher ${isEntitled ? 20 : 5}% Rabattcode`}
              values={{ discountAmount: isEntitled ? 20 : 5 }}
            />
          </p>

          <span data-test-ctx='turtlebox-discount-code' className={css(styles.discountCode)}>
            {discountCode}
          </span>

          <div className={css(styles.infoContainer)}>
            <Font>
              <i className={`is24-icon-info ${css(styles.infoIcon)}`} />
            </Font>
            <p>
              {t({
                id: 'benefits.relocationBox.modal.overview.discoutContainer.info1',
                defaultMessage: 'Dein Rabattcode wird im Warenkorb automatisch eingelöst.',
              })}
            </p>
          </div>

          <Font>
            {t({
              id: 'benefits.relocationBox.modal.overview.discoutContainer.info2',
              defaultMessage:
                'Deinen persönlichen Rabattcode kannst Du im Online-Shop von Turtlebox einmalig einlösen. Ein neuer Code wird nach 4 Wochen automatisch generiert.',
            })}
          </Font>
          <br />
          <Font>
            {t({
              id: 'benefits.relocationBox.modal.overview.discoutContainer.info3',
              defaultMessage:
                'Auf Fremdleistungen von Turtlebox wie Kurier- oder Speditionsleistungen kann der Rabatt leider nicht angerechnet werden.',
            })}
          </Font>
        </>
      ) : (
        <div className={css(styles.loaderContainer)}>
          <Loader />
        </div>
      )}
    </div>
  );
};
